import { Box, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";

const MiniLoader = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: `linear-gradient(135deg, ${theme.palette.primary.main}10, ${theme.palette.background.light3})`,
                flexDirection: "column",
                textAlign: "center",
            }}
        >
            {/* Outer Pulse Ring */}
            <motion.div
                animate={{
                    scale: [1, 2, 1],
                    opacity: [0.6, 0.3, 0.6],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                }}
                style={{
                    position: "absolute",
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    border: `3px solid ${theme.palette.primary.main}`,
                    filter: "blur(1px)",
                }}
            />

            {/* Spinner */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, rotate: 360 }}
                transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: "linear",
                }}
            >

            </motion.div>

            {/* Text */}
            <Typography
                variant="h6"
                sx={{
                    mt: 4,
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                    letterSpacing: "0.5px",
                }}
            >
                Please wait...
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.text.secondary,
                    mt: 1,
                    fontSize: "0.9rem",
                }}
            >
                Loading your data securely
            </Typography>
        </Box>
    );
};

export default MiniLoader;
